import React, { useCallback, useEffect, useState } from 'react'
import MaterialTable, { Filter } from 'material-table'

// Providers
import { localization } from 'providers/material-table/localization'
import { options } from 'providers/material-table/options'

// Components
import Header from 'components/Header'
import SectionTitle from 'components/SectionTitle'

// Services
import api from 'services/api'

// Types
import { Subject, UsersApiResponse } from './interfaces'

// Styles
import Layout from 'layouts/Logged'
import { ClearButton, Container, TableContainer } from './styles'

const Subjects: React.FC = () => {
  /*
  |-----------------------------------------------------------------------------
  | States.
  |-----------------------------------------------------------------------------
  |
  |
  */
  const [isLoading, setIsLoading] = useState(false)
  const [subjects, setSubjects] = useState<Subject[]>([])
  const [perPage, setPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalSubjects, setTotalSubjects] = useState(0)
  const [filters, setFilters] = useState('')

  /*
  |-----------------------------------------------------------------------------
  | Functions.
  |-----------------------------------------------------------------------------
  |
  |
  */
  const fetchSubjects = useCallback(
    (page: number, limit: number, filters: string) => {
      setIsLoading(true)
      api
        .get<UsersApiResponse>(
          `/admin/subjects?page=${page}&limit=${limit}${filters}`,
        )
        .then(({ data }) => {
          setSubjects(data.data)
          setTotalSubjects(data.meta.total)
        })
        .catch(console.trace)
        .finally(() => setIsLoading(false))
    },
    [],
  )

  const newFiltersHandler = useCallback((newFilters: Filter<Subject>[]) => {
    setCurrentPage(1)
    setFilters(
      newFilters
        .map(
          ({ column: { field }, operator, value }) =>
            `&${field}${operator}${value}`,
        )
        .join(''),
    )
  }, [])

  /*
  |-----------------------------------------------------------------------------
  | Effects.
  |-----------------------------------------------------------------------------
  |
  |
  */
  useEffect(() => {
    fetchSubjects(currentPage, perPage, filters)
  }, [currentPage, fetchSubjects, filters, perPage])

  /*
  |-----------------------------------------------------------------------------
  | Renders.
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <Layout>
      <Container>
        <Header
          title="SubTemas"
          subTitle="Lista completa de subtemas da plataforma"
        />
        <SectionTitle>Subtemas</SectionTitle>
        <TableContainer>
          <MaterialTable
            title="Lista de subtemas"
            localization={localization}
            editable={{
              onRowDelete: async rowData => {
                await api.delete(`/admin/subjects/${rowData.id}`)
                location.reload()
              },
            }}
            // editable={{
            //   onRowDelete: async d => removeTheme(d.id),
            // }}
            columns={[
              {
                title: 'Nome',
                field: 'name',
                type: 'string',
                resizable: true,
              },
              {
                title: 'Grande Área',
                field: 'field.name',
                type: 'string',
                resizable: true,
                filtering: false,
              },
              {
                title: 'Trilha',
                field: 'field.track.name',
                type: 'string',
                resizable: true,
                filtering: false,
              },
            ]}
            page={currentPage - 1}
            totalCount={totalSubjects}
            onChangePage={(newPage, perPage) => {
              setCurrentPage(newPage + 1)
              setPerPage(perPage)
            }}
            onChangeRowsPerPage={newPerPage => setPerPage(newPerPage)}
            // onRowClick={(_, rowData) => {
            //   history.push(`/users/${rowData?.id}`)
            // }}
            onFilterChange={newFiltersHandler}
            data={subjects}
            isLoading={isLoading}
            options={options}
          />
          {filters.length > 0 && (
            <ClearButton onClick={() => setFilters('')}>
              limpar filtros
            </ClearButton>
          )}
        </TableContainer>
      </Container>
    </Layout>
  )
}

export default Subjects
